export default "assets/5b36ae581234e0ef92c254c2a493ff5a.png";